<template>
  <div>
    <TheNuxtLink
      v-if="validIsNuxtLink(data)"
      :to="data.link?.url || ''"
      :title="data.name"
      class="menu-link"
    >
      <span class="block w-full break-words">{{ data.name }}</span>
    </TheNuxtLink>
    <button
      v-if="!validIsNuxtLink(data)"
      class="menu-link"
      :title="data.name"
      :class="[current && 'current']"
      @click="$emit('click')"
    >
      <span class="block w-full break-words">{{ data.name }}</span>
      <IconCaret
        direction="right"
        class="menu-link-arrow absolute right-1 top-1 block h-6 w-6 text-gray-600"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatMenu, IFormatProductMenu } from '@/stores/menuStore';

  interface IProps {
    data: IFormatMenu | IFormatProductMenu;
    current?: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    current: false,
  });

  defineEmits<{
    (e: 'click'): void;
  }>();
</script>

<style lang="scss" scoped>
  .menu-link {
    @apply relative block w-full rounded py-1 pl-2 pr-7 text-left text-base font-bold hover:text-blue-400 hover:underline;

    &:hover .menu-link-arrow {
      @apply text-blue-400;
    }

    &.router-link-exact-active {
      @apply text-blue-400;
    }

    &.current {
      @apply bg-blue-100 text-blue-400;

      .menu-link-arrow {
        @apply text-blue-400;
      }
    }
  }
</style>
